module.exports = __webpack_public_path__ + "media/public/images/icon-in-favorite-4d448e554c98bdc6977036865a13d1c1.svg";